import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import request from "../utils/request";

const useAddSubscriptionPayment = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async (data) => {
			const response = await request.post("subscriptionPayment", data);
			return response;
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["subscriptionPayment"] });
		},
	});
};

const useGetAllSubscriptionPayment = () => {
	return useQuery({
		queryKey: ["subscriptionPayment"],
		queryFn: async () => {
			const response = await request.getAll(
				"subscriptionPayment?payment_status=success",
			);
			return response?.status === "OK" ? response.data : [];
		},
		placeholderData: [],
		staleTime: 1000 * 60 * 60 * 24, // 24 hours
	});
};

const useGetSubscriptionMoneyRecieptById = (id) => {
	return useQuery({
		queryKey: ["subscriptionPayment", id],
		queryFn: async () => {
			const response = await request.getAllById("subscriptionPayment", id);
			console.log("response", response);
			return response?.status === "OK" ? response.data : null;
		},
		staleTime: 1000 * 60 * 60 * 24, // 24 hours
	});
};

export {
	useAddSubscriptionPayment,
	useGetAllSubscriptionPayment,
	useGetSubscriptionMoneyRecieptById,
};
